import { Component, OnInit, Injector, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// components
import { DxPopupComponent } from 'devextreme-angular';
import { ItemDetailsComponent } from '../../../shared/components/item-details/item-details.component';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

// models
import { DistributionNumberRange } from '../../../shared/models/distribution-number-range';

// services
import { DistributionManagementService } from '../../shared/services/distribution-management.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'distribution-number-range-component',
  templateUrl: 'distribution-number-range.component.html',
  styleUrls: ['./distribution-number-range.component.scss']
})
export class DistributionNumberRangeComponent extends ItemDetailsComponent<DistributionNumberRange> implements OnInit, OnDestroy {

  @ViewChild('name', { read: ElementRef }) nameInput: any;
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  auctionClusterId: number;
  masterDataLookupSource: DataSource;

  constructor(
    protected injector: Injector,
    private dataService: DistributionManagementService,
    private masterDataService: MasterDataService,
    private translateService: TranslateService
  ) {
    super(injector);
    this._subscription = this.language.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });

    this.masterDataLookupSource = new DataSource({
          paginate: true,
          pageSize: 20,
          requireTotalCount: false,
          store: new CustomStore({
                  key: 'masterDataListRowId', 
                  load: async (loadOptions) => {
                    var result = await this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/, 
                      this.auctionClusterId, this.translateService.currentLang, null, loadOptions).toPromise();

                      if(result.data.length == 1) {
                        this.model.masterDataListRowId = result.data[0].value;
                      }
                      return result.data;
                  },
                  byKey: async (key) => {
                    var result = await this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/, 
                      this.auctionClusterId, this.translateService.currentLang, key, null).toPromise();
                      return result.data[0]
                  }
                })
            });
  }

  ngOnInit() {
    this.model = new DistributionNumberRange();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  open(distributionNumberRangeId: number, auctionClusterId: number) {
    this.auctionClusterId = auctionClusterId;

    if (distributionNumberRangeId != null) {
      this.isEditMode = true;
      this.spinner.show();
      this.dataService.getDistributionNumberRange(this.auctionClusterId, distributionNumberRangeId)
        .subscribe((res: DistributionNumberRange) => {
          this.model = res;
          this.isOpened = true;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
            this.spinner.hide();
          });
    } else {
      this.model = new DistributionNumberRange();
      this.isEditMode = false;
      this.isOpened = true;
      this.masterDataLookupSource.load();
    }
  }

  save() {
    this.model.auctionClusterId = this.auctionClusterId;
     if (this.isEditMode) {
      this.spinner.show();
      this.dataService.editDistributionNumberRange(this.auctionClusterId, this.model)
        .subscribe((res: any) => {
          this.model = new DistributionNumberRange();
          this.close(true);
          this.errorMessage = null;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
          this.spinner.hide();
        });
     } else {
      this.spinner.show();
       this.dataService.saveDistributionNumberRange(this.auctionClusterId, this.model)
        .subscribe((res: any) => {
          this.model = new DistributionNumberRange();
          this.close(true);
          this.errorMessage = null;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
          this.spinner.hide();
        });
     }
  }


  onFieldDataChanged(e: any) {
    if (e.component._isReady && e.component.NAME !== 'dxPopup') {
      const result = e.component.validate();
      if (result.brokenRules.length >= 1) {
        document.getElementsByName('btnDistributionNumberRangeSubmit')[0].setAttribute('disabled', 'disabled');
      } else {
        document.getElementsByName('btnDistributionNumberRangeSubmit')[0].removeAttribute('disabled');
      }
    } else {
      if (this.isEditMode) {
        document.getElementsByName('btnDistributionNumberRangeSubmit')[0].removeAttribute('disabled');
      }
    }
  }
}
